import { Controller } from "@hotwired/stimulus"

export default class ChatPanelController extends Controller {
  static targets = ["panel", "bubble", "frame"]
  static values = { conversationUrl: String }

  connect() {
    this.frameTarget.addEventListener("turbo:frame-load", () => {
      this.frameTarget.classList.remove("invisible")
    })
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.frameTarget.classList.add("invisible")
    this.frameTarget.src = this.conversationUrlValue
    this.panelTarget.classList.remove("translate-x-full")
    this.bubbleTarget.classList.add("hidden")
    document.body.style.marginRight = `${this.panelTarget.offsetWidth}px`
    document.body.style.transition = "margin-right 200ms ease"
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.bubbleTarget.classList.remove("hidden")
    document.body.style.marginRight = ""
  }

  get isOpen() {
    return !this.panelTarget.classList.contains("translate-x-full")
  }
}
